const location = {
  title: 'Allow location access',
  description: 'This is a security requirement of this signing process.',
  action: 'Next',
  error: 'Activate location in your browser',
  help: 'Having trouble granting access?',
};

export default location;
